<template>
    <div>

        <div class="dropdown float-left">
            <button type="button" :disabled="isLoading"
                    class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                    id="optionDropDown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                <i v-if="isLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                Sage 300 Options <i class="fa fa-caret-down mx-1"></i>
            </button>
            <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="optionDropDown">
                <button v-if="canErpCreate" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-followup' || project.sage_cre_project_no" @click.prevent.stop="pushProject">
                    Connect/Push to Sage 300
                </button>
                <button v-if="canErpUpdate" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-followup' || !project.sage_cre_project_no" @click.prevent.stop="showUpdateProjectPopup">
                    Update Job on Sage 300
                </button>
                <button v-if="canErpSync" type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-third-party'"  @click.prevent="syncProjectFromAgave" >
                    Sync from Sage 300
                </button>
                <span>
                    <button type="button" class="dropdown-item py-2" :disabled="mapping.direction === 'one-way-third-party'"  @click.prevent="project.sage_cre_project_no ? $parent.$refs.Sage300IncomeCost.getIncomeVsCostData() : syncProjectFromAgave()">
                        Pull Income Cost Summary
                    </button>
                </span>
            </div>
        </div>

        <div class="modal" id="customerSelectionModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Contact</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('customerSelectionModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select contact to associate with the Sage 300 Job</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="companyContacts"
                                    v-model="selectedContact"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                <template slot="option" slot-scope="props">
                                    {{ props.option.name }} <span v-if="props.option.sage_cre_customer_no" class="text-sm mb-3 text-teal syncced">Synced with Sage 300</span>
                                </template>
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="selectedContact && selectedContact.sage_cre_customer_no" class="text-sm mb-3 text-teal">The contact is already synced with Sage 300</div>
                        <div v-if="selectedContact && !selectedContact.sage_cre_customer_no" class="text-sm mb-3 text-teal">Note: You have selected a contact that is not synced with Sage 300. Clicking on Push will link the contact to an existing customer on Sage 300 if the email address matches. If email address does not match, a new customer will be created on Sage 300.</div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('customerSelectionModal', true)">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('customerSelectionModal');checkCustomerStatus()" :disabled="!this.selectedContact">Select</button>
                    </div>
                </div>
            </div>
        </div>




        <div class="modal" tabindex="-1" role="dialog" id="updateJobModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the Synced Sage 300 Job.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will replace update the Sage 300 Job that is synced with this project. Are you sure you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('updateJobModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateJobOnAgave">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncJobConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this project with info from the Sage 300 Job.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('syncJobConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pullJobFromAgave()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncJobFromAgaveModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium" v-if="!syncFromAgaveStepTwo">This project is not synced with a Sage 300 Job</h5>
                        <h5 class="modal-title text-teal font-medium" v-else>WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncJobFromAgaveModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromAgaveStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Sage 300 Job to sync this project with</label>
                                <div v-if="fetchingAgaveJobs" class="spinner text-sm text-teal">
                                    Fetching jobs from Sage 300...
                                </div>
                                <multiselect
                                    v-model="selectedAgaveJob"
                                    :options="agaveJobList"
                                    @search-change="onInputChange"
                                    label="label"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Searching Sage 300 Job..."
                                    :loading="fetchingAgaveJobs"
                                    :closeOnSelect="true"
                                    ref="jobMultiselect"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromAgaveModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedAgaveJob" @click.prevent="() => syncFromAgaveStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p>This will overwrite certain fields of this project with info from the Sage 300 Job.</p>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromAgaveModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedAgaveJob" @click.prevent="pullJobFromAgave">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="selectChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Sage 300 Change Order</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('selectChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select Sage 300 Change Order</label>
                                <multiselect
                                    v-model="selectedAgaveChangeOrder"
                                    :options="changeOrders"
                                    label="name"
                                    track-by="id"
                                    :multiple="false"
                                    placeholder="Select Sage 300 Change order..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('selectChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedAgaveChangeOrder" @click.prevent="closeModal('selectChangeOrderModal');openModal('changeOrderConfirmModal')">Select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="changeOrderConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - Replace Change Order fields with data from Sage 300 ?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will pull in data from a Change Order in Sage 300 and replace the fields on Followup, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="syncChangeOrderData()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('changeOrderConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- -------------------------------Residential Modals----------------------- -->

        <div class="modal" id="getResidentialCustomerCode" tabindex="-1" data-backdrop="static" data-keyboard="false" v-if="selectedContact">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Sage 300 Residential Custom Customer Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('getResidentialCustomerCode', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Enter the custom customer number to create residential customer on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns" style="column-count: 1 ; -moz-column-count : 1">
                                    <li class="form-check">
                                       <label>
                                           <span>"{{ customResidentialCustomerCodeFieldName }}" for customer "<b>{{ selectedContact.name }}</b>"</span>
                                        </label>
                                        <input type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-4/5" v-model="selectedContact.custom_customer_code" :placeholder="customResidentialCustomerCodeFieldName + ' (The five character code for the Customer)'" maxlength="5" />
                                    </li>
                                    <br>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('getResidentialCustomerCode', true)">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="checkResidentialContactCodeField()" :disabled="!selectedContact.custom_customer_code || selectedContact.custom_customer_code.length > 5" title="The five character code for the Customer">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="getResidentialContactCode" tabindex="-1" data-backdrop="static" data-keyboard="false" v-if="selectedContact">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Sage 300 Residential Custom Contact Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('getResidentialContactCode', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Enter the custom contact number to create residential contact on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns" style="column-count: 1 ; -moz-column-count : 1">
                                    <li class="form-check">
                                        <label>
                                            <span>"{{ customResidentialContactCodeFieldName }}" for contact "<b>{{ selectedContact.name }}</b>"</span>
                                        </label>
                                        <input type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-4/5" v-model="selectedContact.custom_contact_code" :placeholder="customResidentialContactCodeFieldName + ' (should be three character code)'" maxlength="3" minlength="3" />
                                    </li>
                                    <br>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('getResidentialContactCode', true)">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushResidentialContactToAgave()" :disabled="!selectedContact.custom_contact_code || selectedContact.custom_contact_code.length != 3" title="Contact Code should be 3 characters long">Push</button>
                    </div>
                </div>
            </div>
        </div>


        <!-- -------------------------------Residential Modals End----------------------- -->


        <!-- -------------------------------Non-Residential Customer Modals ----------------------- -->

        <div class="modal" id="getCustomerCode" tabindex="-1" data-backdrop="static" data-keyboard="false" v-if="selectedCompany">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Sage 300 Custom Customer Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('getCustomerCode')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Enter the custom customer number to create customer on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns" style="column-count: 1 ; -moz-column-count : 1">
                                    <li class="form-check">
                                       <label>
                                           <span>"{{ customCustomerCodeFieldName }}" for customer "<b>{{ selectedCompany.name }}</b>"</span>
                                        </label>
                                        <input type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-4/5" v-model="selectedCompany.custom_customer_code" :placeholder="customCustomerCodeFieldName + ' (The five character code for the Customer)'" maxlength="5" />
                                    </li>
                                    <br>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('getCustomerCode')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="getContactListToPush()" :disabled="!selectedCompany.custom_customer_code || selectedCompany.custom_customer_code.length > 5" title="The five character code for the Customer">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="getContactListToPush" tabindex="-1" data-backdrop="static" data-keyboard="false" v-if="selectedCompany">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Connect/Push</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('getContactListToPush')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Select contacts to push to Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns">
                                    <li v-for="contact in selectedCompany.contacts" class="form-check">
                                       <label>
                                         <input type="checkbox" v-model="selectedCompanyContactForAgave" :value="contact" />
                                         <span>{{ contact.name }}</span>
                                       </label>
                                    </li>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('getContactListToPush')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="checkContactCodeField()" :disabled="!selectedCompanyContactForAgave.length">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="getContactsCode" tabindex="-1" data-backdrop="static" data-keyboard="false" v-if="selectedCompany">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Sage 300 Custom Contact Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('getContactsCode')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <p>Enter the custom contact numbers to create contacts on Sage 300</p>
                                <br>
                                <ul class="checkboxcolumns" style="column-count: 1 ; -moz-column-count : 1">
                                    <li v-for="contact in selectedCompanyContactForAgave" class="form-check">
                                       <label>
                                           <span>"{{ customContactCodeFieldName }}" for contact "<b>{{ contact.name }}</b>"</span>
                                        </label>
                                        <input type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-4/5" v-model="contact.custom_contact_code" :placeholder="customContactCodeFieldName + ' (should be three character code)'" maxlength="3" minlength="3" />
                                    </li>
                                    <br>

                                </ul>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('getContactsCode')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="createCustomerAndContactOnAgave()" :disabled="selectedCompanyContactForAgave.some(obj => !obj.custom_contact_code || obj.custom_contact_code.length != 3)" title="Contact Code should be 3 characters long">Push</button>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
    name: 'sage-300-project',
    components: {Multiselect},
    props: [
        'project',
        'companyContacts',
        'customJobNumberFieldId',
        'mapping',
        'customCustomerCodeFieldId',
        'customCustomerCodeFieldName',
        'customContactCodeFieldId',
        'customContactCodeFieldName',

        'customResidentialCustomerCodeFieldId',
        'customResidentialCustomerCodeFieldName',

        'customResidentialContactCodeFieldId',
        'customResidentialContactCodeFieldName',
        'canErpCreate',
        'canErpUpdate',
        'canErpSync'
    ],
    data() {
        return {
            selectedCompany : null,
            isLoading: false,
            selectedCompanyContactForAgave : [],
            selectedContact: null,
            selectedAgaveJob: null,
            agaveJobList: [],
            syncFromAgaveStepTwo: false,
            fetchingAgaveJobs: false,
            fetchingJobsCount: 0,
            customJobNumber: null,
            changeOrders: [],
            selectedAgaveChangeOrder: null,  //agaveChangeOrder
            selectedProjectChangeOrder: null   //Followup ChangeOrder
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 1000);
    },
    mounted() {
    },
    methods: {
        checkJobNumberFormat(jobNum){
            const pattern = /^[0-9a-zA-Z][0-9A-Z]-[0-9A-Z]{3}$/;
            if(pattern.test(jobNum)){
                return true;
            }
            return false;
        },
        pushProject(){
            if(this.customJobNumberFieldId){
                let jobNumber = this.getSafe(() => this.$parent.$refs.CustomFields.form[this.customJobNumberFieldId]);
                if(jobNumber){
                    if(this.checkJobNumberFormat(jobNumber)){
                        this.customJobNumber = jobNumber;
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Invalid Job # Format: must be in the format `xX-XXX`: each x/X is a digit or letter and the lowercase x is optional.'
                        });
                        return;
                    }
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: 'Sage 300 Job # is required'
                    });
                    return;
                }
            }

            this.selectedContact = null;
            $('#customerSelectionModal').modal('show');

        },

        checkCustomerStatus(){
            this.$nextTick( async ()=>{
                if(this.selectedContact.is_contact_residential){
                    if(this.selectedContact.sage_cre_customer_no){
                        this.pushToAgave(this.selectedContact.agave_customer_no);
                    }else{
                        this.checkResidentialCustomerCodeField();
                    }
                }else{
                    if(this.selectedContact.sage_cre_customer_no){
                        this.pushToAgave(this.selectedContact.agave_customer_no);
                    }else{
                        this.checkIfCompanyIsSyncedWithAgaveWithOtherContact(this.selectedContact.company_id)
                    }
                }

            })
        },
        /*******************************Residential Contact Handing --------------*/
        checkResidentialCustomerCodeField() {
            if(this.customResidentialCustomerCodeFieldId){
                this.openModal('getResidentialCustomerCode');
                return;
            }
            this.checkResidentialContactCodeField();
        },
        checkResidentialContactCodeField() {
            this.closeModal('getResidentialCustomerCode');
            if(this.customResidentialContactCodeFieldId){
                this.openModal('getResidentialContactCode');
                return;
            }
            this.pushResidentialContactToAgave();
        },
        pushResidentialContactToAgave() {
            let self = this;
            this.closeModal('getResidentialCustomerCode');
            this.closeModal('getResidentialContactCode');
            let payload = {
                    'contact_id': this.selectedContact.id,
                    'customCustomerCode' : this.selectedContact.custom_customer_code,
                    'customCustomerCodeFieldId' : this.customResidentialCustomerCodeFieldId,
                    'customContactCode' : this.selectedContact.custom_contact_code,
                    'customContactCodeFieldId' : this.customResidentialContactCodeFieldId
                };
                self.isLoading = true;
                axios.post(route('api.sage300.connect-residential-customer-and-contact-on-agave'), payload).then((response) => {
                    self.isLoading = false;

                    if (response.data.status === 'success') {
                        // self.getToast(3000).fire({ type: 'success', title: response.data.message });
                        this.pushToAgave(response.data.agave_customer_no);

                    } else {
                        self.getToast().fire({ type: 'error', title: response.data.message });
                    }
                });
        },
        /*******************************Residential Contact Handing End--------------*/
        checkIfCompanyIsSyncedWithAgaveWithOtherContact(companyId){
            axios.post(route('api.sage300.get-company-and-contacts'), {companyId: companyId}).then((response) => {
                if(response.data.status == 'success'){
                    this.selectedCompany = response.data.company;
                    let customerAgaveNo = this.selectedCompany.agave_customer_no;
                    if(!this.selectedCompany){
                        this.getToast().fire({
                            type: 'error',
                            title: 'Selected Company does not exists'
                        });
                        return;
                    }
                    if(customerAgaveNo){
                        this.pushToAgave(customerAgaveNo);
                        //create/link that contact with company
                    }else{
                        this.linkCompanyOnAgave(this.selectedContact.company_id);
                    }

                }
            });
        },
        linkCompanyOnAgave(company_id){
            let self = this;
            let payload = {'company_id': company_id, type: 'Company'};
            self.isLoading = true;
            axios.post(route('api.sage300.connect-customer-on-agave'), payload).then((response) => {
                self.isLoading = false;
                if(response.data.status == 'success'){
                    self.getToast(3000).fire({type: 'success',title: response.data.message});
                    let linkedCustomerAgaveId = response.data.agave_customer_no;
                    if(linkedCustomerAgaveId){
                        this.pushToAgave(linkedCustomerAgaveId);
                        return;
                    }
                }
                self.getToast(3000).fire({type: 'eroor',title: response.data.message});
                this.checkCustomerCodeFieldAndCreateCustomer();

            });
        },
        checkCustomerCodeFieldAndCreateCustomer() {
            if(this.customCustomerCodeFieldId){
                this.openModal('getCustomerCode');
                return;
            }
            this.getContactListToPush();
        },
        getContactListToPush() {
            this.closeModal('getCustomerCode');
            if(this.selectedCompany.contacts){
                this.openModal('getContactListToPush');
                return;
            }
            this.createCustomerAndContactOnAgave();
        },
        checkContactCodeField() {
            this.closeModal('getContactListToPush');
            if(this.customContactCodeFieldId){
                this.openModal('getContactsCode');
                return;
            }
            this.createCustomerAndContactOnAgave();
        },
        createCustomerAndContactOnAgave(){
            let self = this;
            let payload = {
                'company_id': this.selectedCompany.id,
                'contact': this.selectedCompanyContactForAgave,
                'customContactCodeFieldId' : this.customContactCodeFieldId,
                'type': 'Company',
                'customCustomerCode' : this.selectedCompany.custom_customer_code,
                'customCustomerCodeFieldId' : this.customCustomerCodeFieldId
            };
            self.isLoading = true;
            self.closeModal('getCustomerCode');
            self.closeModal('getContactListToPush');
            self.closeModal('getContactsCode');
            axios.post(route('api.sage300.create-customer-on-agave'), payload).then((response) => {
                self.isLoading = false;

                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });

                    let agaveCustomerNo = response.data.agave_customer_no;

                    this.selectedContact.sage_cre_customer_no = this.selectedCompany.sage_cre_customer_no || response.data.customer_no
                    this.selectedContact.agave_customer_no = this.selectedCompany.agave_customer_no || response.data.agave_customer_no
                    this.pushToAgave(agaveCustomerNo);
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        pushToAgave(agaveId = null){
            let self = this;

            let data = {
                customJobNumber: self.customJobNumber,
                project_id: self.project.id,
                // timeZone: self.getTimeZoneWithFormat(),
                agaveCustomerId: agaveId || this.getSafe(() => self.selectedContact.agave_customer_no) || null,
                customJobNumberFieldId: self.customJobNumberFieldId
            };
            this.isLoading = true;
            axios.post(route('api.sage300.push-project-to-agave'), data).then((response) => {
               this.isLoading = false;
               if(response.data.status == 'success'){
                   self.getToast().fire({
                       type: 'success',
                       title: response.data.message
                   });
                   setTimeout(() => {
                        window.location.reload();
                   }, 3000)
               }else{
                   self.getToast().fire({
                       type: 'error',
                       title: response.data.message
                   });
               }
            });

        },
        showUpdateProjectPopup(){
            if(this.project.sage_cre_project_no){
                $('#updateJobModal').modal('show');
            }
        },

        updateJobOnAgave(){
            let self = this;
            this.isLoading = true;
            self.closeModal('updateJobModal');
            axios.post(route('api.sage300.update-project-to-agave'), {projectId: this.project.id}).then((response) => {
                this.isLoading = false;
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    // setTimeout(() => {
                    //         window.location.reload();
                    // }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },

        syncProjectFromAgave(){
            if(this.project.sage_cre_project_no){
                $('#syncJobConfirmModal').modal('show');
            }else{
                $('#syncJobFromAgaveModal').modal('show');
            }
        },
        openModal(modalId) {
            $('#'+modalId).modal('show');
            if(modalId === 'customerSelectionModal'){
                this.selectedContact = null;
            }
        },
        closeModal(modalId, isCancelled = false) {
            $('#'+modalId).modal('hide');
            const modalIds = ['customerSelectionModal', 'getResidentialCustomerCode', 'getResidentialContactCode'];
            if(isCancelled && modalIds.includes(modalId)) {
                this.$emit('pushProjectCancelled');
            }
        },

        onInputChange(value) {
            if (value.length >= 1) {
                this.fetchingAgaveJobs = true;
                this.debouncedFilterOptions(value);
            }
        },
        filterOptions(input) {
            let self = this;
            this.fetchingJobsCount = this.fetchingJobsCount+1;
            axios.post(route('api.sage300.search-job-from-agave'), {search: input}).then((response) => {
                this.fetchingJobsCount = this.fetchingJobsCount - 1;
                this.$nextTick(() => {
                    if(self.fetchingJobsCount === 0){
                        self.fetchingAgaveJobs = false;
                    }
                })
                if(response.data.status == 'success'){
                    self.agaveJobList = response.data.jobs;

                  self.agaveJobList = self.agaveJobList.map((job) => {
                    let label = job.number + ' | ' + job.name
                    return {
                      ...job,
                      "label": label
                    }
                  })

                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        pullJobFromAgave(){
            let self = this;
            this.isLoading = true;
            let data = {
                projectId: this.project.id,
                agaveJobId: this.project.agave_project_no || this.getSafe(() => this.selectedAgaveJob.id) || null
            }
            self.closeModal('syncJobConfirmModal');
            self.closeModal('syncJobFromAgaveModal');
            axios.post(route('api.sage300.sync-project-from-agave'), data).then((response) => {
                this.isLoading = false;
                if(response.data.status == 'success'){

                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },
        syncSage300ChangeOrder(changeOrder){
            this.selectedProjectChangeOrder = changeOrder;
            if(!this.project.sage_cre_project_no){
                return this.syncProjectFromAgave();
            }

            if(changeOrder.agave_change_order){
                this.openModal('changeOrderConfirmModal');
            }else{
                this.fetchJobChangeOrdersList();
            }

        },
        fetchJobChangeOrdersList(){
            this.isLoading = true;
            this.getToast(3500).fire({
                type: 'success',
                title: 'Fetching change orders from Sage 300'
            });
            let data = {
                agave_project_no: this.project.agave_project_no,
            }
            axios.get(route('api.sage300.get-change-orders', data)).then((response) => {
                this.isLoading = false;
                this.changeOrders = response.data;
                this.openModal('selectChangeOrderModal');

            });
        },
        syncChangeOrderData(){
            this.isLoading = true;
            this.closeModal('changeOrderConfirmModal');
            let data = {
                agave_change_order_id: this.selectedProjectChangeOrder.agave_id || this.selectedAgaveChangeOrder.id,
                project_change_order_id: this.selectedProjectChangeOrder.id,
                project_id: this.project.id,
            }
            this.getToast(3500).fire({
                type: 'success',
                title: 'Syncing change order data from Sage 300'
            });
            axios.get(route('api.sage300.sync-change-order-data', data) ).then((response) => {
                this.isLoading = false;
                this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            });
        },
        getTimeZoneWithFormat() {
            const now = new Date();
            const offsetMinutes = now.getTimezoneOffset();
            const offsetHours = Math.abs(offsetMinutes) / 60;
            const offsetSign = offsetMinutes < 0 ? '+' : '-';
            const timeZoneOptions = { timeZoneName: 'long' };
            const timeZoneFormat = new Intl.DateTimeFormat('en-US', timeZoneOptions);
            const timeZone = timeZoneFormat.format(new Date());
            const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formattedOffset = `UTC${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(Math.abs(offsetMinutes % 60)).padStart(2, '0')}`;
            const formattedTimeZone = `(${formattedOffset}) ${timeZone}`;

            return formattedTimeZone;
        },

    }
}
</script>
<style>
     .modal-backdrop {
      /* bug fix - no overlay */
      display: none;
}

.modal{
    /* bug fix - custom overlay */
    background-color: #2625258f;
}
.multiselect__option--highlight .syncced{
    color: black;
}
.checkboxcolumns {
        column-count: 2;
        column-gap: 2rem;
        list-style: none;
        padding: 0;
    }
</style>
